export default __webpack_public_path__ + "static/media/partnership.1a1718b4.svg";